// extracted by mini-css-extract-plugin
export default {"container":"ConfirmDenominationModal_container__QSPok","warning-icon":"ConfirmDenominationModal_warning-icon__wmYtz","title":"ConfirmDenominationModal_title__EkpTk"};